import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class PlusIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path d="M6 4h4v2H6v4H4V6H0V4h4V0h2z"/></svg>
        )
    }
}

export default withCssClassName(PlusIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/plus-icon.js